import BasketLoves from 'components/Loves/BasketLoves/BasketLoves';
import withBasketLovesProps from 'viewModel/loves/basketLoves/withBasketLovesProps';

export default withBasketLovesProps(BasketLoves);
